// Module
var code = "<template> <require from=\"./terms-eightysix-borders.scss\"></require> <div class=\"terms-eightysix-borders\"> <iframe id=\"terms-link\" src=\"https://86borders.com/terms\" if.bind=\"language == 'en'\"> </iframe> <iframe id=\"terms-link\" src=\"https://86borders.com/terms/es/\" if.bind=\"language == 'es'\"> </iframe> </div> </template> ";
// Exports
export default code;